import {useEffect,useRef,useState} from 'react';
import api,{downloadFile,getErrorMessage} from '@/lib/api';
import NativeWordHistory from './NativeWordHistory';

// Firm standard (Alif) print layout of one working paper: structure preview, the earlier layouts and the Word history.
// Read-only: exporting never changes status, sign-off or content.
export default function AlifFormatExport({id,wid,wpRef}){
 const [preview,setPreview]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState('');
 const request=useRef(0);
 useEffect(()=>{request.current+=1;setPreview(null);setError('');},[wid]);
 useEffect(()=>()=>{request.current+=1;},[]);
 const load=async()=>{
  const ticket=++request.current;setBusy(true);setError('');
  try{const {data}=await api.get(`/ewps/${wid}/alif-format/preview`);if(ticket===request.current)setPreview(data);}
  catch(e){if(ticket===request.current)setError(getErrorMessage(e));}
  finally{if(ticket===request.current)setBusy(false);}
 };
 const download=async(path,name)=>{
  const ticket=request.current;setError('');
  try{await downloadFile(path,name);}catch(e){if(ticket===request.current)setError(getErrorMessage(e));}
 };
 const ref=wpRef||'KKA';
 // Lead schedules: the basis behind each number and its explanation, exactly as the exports print them.
 const numeric=(preview?.sheets?.[1]?.blocks||[]).filter(block=>block.role==='numeric');
 return <div className="text-xs border p-2 space-y-2" data-testid="alif-format">
  <div className="flex flex-wrap items-center gap-2">
   <span className="font-semibold">Format standar KAP (siap cetak) — tombol .xlsx / Word di atas</span>
   <button type="button" className="border rounded px-2 py-1" data-testid="alif-preview" disabled={busy} onClick={load}>{busy?'Memuat…':'Pratinjau struktur'}</button>
   <span className="text-muted-foreground">Format lama:</span>
   <button type="button" className="underline" data-testid="legacy-export-xlsx" onClick={()=>download(`/ewps/${wid}/export`,`KKA_${ref}.xlsx`)}>.xlsx</button>
   <button type="button" className="underline" data-testid="legacy-export-docx" onClick={()=>download(`/ewps/${wid}/export/docx`,`KKA_${ref}.docx`)}>Word</button>
  </div>
  {error&&<div role="alert" className="text-red-700">{error}</div>}
  {preview&&<div data-testid="alif-preview-result" className="space-y-1">
   <div>Template {preview.template.code} — {preview.template.title} · dasar pemilihan: {preview.selection.basis} ({preview.selection.detail})</div>
   <div>Status KKA: {preview.identity.status||'tidak tercatat'} · {preview.draft?'DRAFT — belum final':'Salinan reviu'} · Logo KAP: {preview.identity.logo?'dari Firm branding':'tidak tersedia'}</div>
   <ol className="list-decimal pl-5" data-testid="alif-preview-sheets">{preview.sheets.map(sheet=><li key={sheet.name}>{sheet.name} — {sheet.title}</li>)}</ol>
   {numeric.map(block=><details key={block.title} open data-testid="alif-preview-numeric">
    <summary className="font-semibold">{block.title}</summary>
    {block.groups.length?block.groups.map(group=><div key={group.label} className="pl-2">
     <div className="font-medium">{group.label}</div>
     <ul className="list-disc pl-5">{group.items.map(item=><li key={item}>{item}</li>)}</ul>
    </div>):<div className="pl-2">{block.empty}</div>}
   </details>)}
   <div className="font-semibold">Hal terbuka / batasan</div>
   {preview.open_matters.length
    ?<ul className="list-disc pl-5 text-amber-800" data-testid="alif-preview-open">{preview.open_matters.map(item=><li key={item}>{item}</li>)}</ul>
    :<div>Tidak ada hal terbuka yang tercatat.</div>}
  </div>}
  {id&&<details data-testid="alif-word-history"><summary>Riwayat Word format Alif</summary><NativeWordHistory id={id} exportType="EWP_ALIF" recordId={wid} templates={false}/></details>}
 </div>;
}
